module.exports = __webpack_public_path__ + "static/media/RoundedRect_Orange@3x.c0e3296c.png";